// Telefone BR — celular (11 dígitos com 9 na frente) ou fixo (10 dígitos).
// Aceita formatado "(31) 99733-3998" ou só dígitos.

export function validatePhone(input) {
    if (input == null) return { valid: false, error: 'Informe o telefone.' };

    const digits = String(input).replace(/\D/g, '');
    if (digits.length === 0) return { valid: false, error: 'Informe o telefone.' };
    if (digits.length !== 10 && digits.length !== 11) {
        return { valid: false, error: 'Telefone deve ter 10 ou 11 dígitos.' };
    }

    // DDD válido (11-99, excluindo alguns que não existem)
    const ddd = parseInt(digits.slice(0, 2), 10);
    if (ddd < 11 || ddd > 99) {
        return { valid: false, error: 'DDD inválido.' };
    }

    // Celular precisa começar com 9 no terceiro dígito
    if (digits.length === 11 && digits[2] !== '9') {
        return { valid: false, error: 'Celular deve começar com 9.' };
    }

    return { valid: true };
}

export function formatPhone(input) {
    const digits = String(input || '').replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits.length ? `(${digits}` : '';
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
